import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/电影" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "综艺", to: "/category/综艺" },
  { label: "看片APP", to: "/app" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    if (to === "/app") return location.pathname.startsWith("/app");
    return decodeURIComponent(location.pathname).startsWith(to);
  };

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-950/95 backdrop-blur-md border-b border-primary-800/60">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between gap-4 h-16">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500">
              <i className="ri-movie-2-fill text-xl text-primary-950"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="text-base md:text-lg font-bold text-background-50 tracking-wide">
                看片免费<span className="text-accent-400">app</span>
              </span>
              <span className="hidden sm:block text-[10px] text-primary-300 tracking-[0.18em] font-label">
                FREE MOVIE PORTAL
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3.5 py-2 text-sm rounded-md transition-colors ${
                  isActive(item.to)
                    ? "text-accent-400 bg-primary-900/80"
                    : "text-primary-100 hover:text-background-50 hover:bg-primary-900/60"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:flex items-center">
              <div className="flex items-center gap-2 rounded-full bg-primary-900/80 border border-primary-700/70 pl-3 pr-1 py-1">
                <i className="ri-search-line text-primary-300 text-sm"></i>
                <input
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜索影片 / APP"
                  className="w-36 xl:w-48 bg-transparent text-sm text-background-50 placeholder:text-primary-400 outline-none"
                  aria-label="站内搜索"
                />
                <button
                  type="submit"
                  className="px-3 py-1 rounded-full bg-accent-500 text-primary-950 text-xs font-medium whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  搜索
                </button>
              </div>
            </form>

            <Link
              to="/search"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-primary-900/80 text-background-50"
              aria-label="搜索"
            >
              <i className="ri-search-line"></i>
            </Link>

            <button
              type="button"
              onClick={() => setMobileOpen((open) => !open)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-full bg-primary-900/80 text-background-50 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden fixed inset-x-0 top-16 bottom-0 z-40 bg-primary-950/95 backdrop-blur-md overflow-y-auto">
          <div className="px-4 py-5">
            <form onSubmit={handleSearch} className="flex items-center gap-2 rounded-lg bg-primary-900 border border-primary-700/70 px-3 py-2 mb-5">
              <i className="ri-search-line text-primary-300"></i>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影片 / 电视剧 / APP"
                className="flex-1 bg-transparent text-sm text-background-50 placeholder:text-primary-400 outline-none"
                aria-label="站内搜索"
              />
              <button type="submit" className="text-accent-400 text-sm whitespace-nowrap cursor-pointer">
                搜索
              </button>
            </form>
            <div className="flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center justify-between py-3.5 border-b border-primary-800/70 text-base ${
                    isActive(item.to) ? "text-accent-400" : "text-background-100"
                  }`}
                >
                  <span>{item.label}</span>
                  <i className="ri-arrow-right-s-line text-primary-400"></i>
                </Link>
              ))}
              <Link to="/search" className="mt-6 py-3 rounded-md bg-accent-500 text-primary-950 text-center text-sm font-medium">
                进入搜索页
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}